export default {
	/**
	 * 格式化时间
	 * date:日期
	 * ftm  ：日期格式  yyyy-MM-dd ...
	 */
	fmtDate(date, fmt) {
		var o = {
			"M+": date.getMonth() + 1, //月份 
			"d+": date.getDate(), //日 
			"h+": date.getHours(), //小时 
			"m+": date.getMinutes(), //分 
			"s+": date.getSeconds(), //秒 
			"q+": Math.floor((date.getMonth() + 3) / 3), //季度 
			"S": date.getMilliseconds() //毫秒 
		};
		if (/(y+)/.test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
		}
		for (var k in o) {
			if (new RegExp("(" + k + ")").test(fmt)) {
				fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
					.length)));
			}
		}
		return fmt;
	},
	//通过基准日期获取指定天数的日期对象
	getDateByRange(date = new Date(), range) {
		date.setDate(date.getDate() + range);
		return date;
	},
	//将日期格式获取到的周几转为可读文字
	getWeekDayByNum(flag) {
		let weekdayText = "";
		if (flag == 1) {
			weekdayText = "周一";
		} else if (flag == 2) {
			weekdayText = "周二";
		} else if (flag == 3) {
			weekdayText = "周三";
		} else if (flag == 4) {
			weekdayText = "周四";
		} else if (flag == 5) {
			weekdayText = "周五";
		} else if (flag == 6) {
			weekdayText = "周六";
		} else if (flag == 0) {
			weekdayText = "周日";
		}
		return weekdayText;
	}
}